
export default drawBottomBar
function drawBottomBar(){
    return `
    <div class="bottom-bar-position"></div>
    <div class="bottom-bar">
        <div class="bottom-item index active">首页</div>
        <div class="bottom-item message">消息</div>
        <div class="bottom-item mine">我的</div>
    </div>
    `
}